import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { clientApi } from '../../../../../api/clientApi';
import { SingleColumnLayout } from '../../../../_layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../../../designSystem/PageHeader';
import { P } from '../../../../../designSystem/typography/Body';
import { PublicPageWrapper } from '../../../../_pageWrappers/PublicPageWrapper';

// type loginMethod = 'none' |'magicLink';

export function PortalLoginConfirmPage(): JSX.Element {
    
    const params = useParams<{ siteId:string, email:string, requestId:string }>();

    const [loading, setLoading] = React.useState(true);
    const [success, setSuccess] = React.useState<boolean | null>(null);

    React.useEffect(() => {
        async function getData() {
            const result = await clientApi.portal.confirmMagicLink(params.siteId || '', params.email ||'', params.requestId || '');
            setSuccess(result);
            setLoading(false);
        }
        getData();
    },[params.siteId, params.email, params.requestId]);

    return (
        <PublicPageWrapper siteId={params.siteId}>

                {loading &&
                    <LoadingPageOverlay loading={true} />
                }

                {success 
                
                    ?
                    <Navigate to={`/portal`} />

                    :
                    <>
                        <PageHeader narrow headerText="Bekræft login" />
                        <SingleColumnLayout narrow>
                            <>
                                <P>Vi kunne ikke logged dig ind.</P>
                                
                                <P>Det kan skyldes at linket er udløbet, eller at det er blevet brugt tidligere. Prøv at anmode om et nyt link, og klik på det seneste link du modtager i din email.</P>
                            </>
                        </SingleColumnLayout>
                    </>
                }
        </PublicPageWrapper>
    );
}